import type { PublicCategory, PublicProduct } from "@/types/models";

export type ProductCategorySection = {
  category: PublicCategory;
  products: PublicProduct[];
};

export function categorySectionId(slug: string): string {
  return `category-${slug}`;
}

export const CATALOG_TOP_SECTION_ID = "catalog-top";

/** Group products by store category order; uncategorized items go last. */
export function groupProductsByCategory(
  products: PublicProduct[],
  categories: PublicCategory[]
): ProductCategorySection[] {
  const bySlug = new Map<string, PublicProduct[]>();

  for (const product of products) {
    const slug = product.category?.slug;
    if (!slug) continue;
    const list = bySlug.get(slug) ?? [];
    list.push(product);
    bySlug.set(slug, list);
  }

  const sections: ProductCategorySection[] = [];

  for (const category of categories) {
    const categoryProducts = bySlug.get(category.slug);
    if (categoryProducts?.length) {
      sections.push({ category, products: categoryProducts });
    }
  }

  const uncategorized = products.filter((p) => !p.category?.slug);
  if (uncategorized.length > 0) {
    sections.push({
      category: {
        id: "uncategorized",
        name: "Outros",
        slug: "outros",
        position: Number.MAX_SAFE_INTEGER,
      },
      products: uncategorized,
    });
  }

  return sections;
}
